import React from 'react';
import { useTranslation } from 'react-i18next';
import type { WorkflowTemplate } from './WorkflowTemplatesDialog';

interface TemplateListViewProps {
  templates: WorkflowTemplate[];
  categories: Array<{ value: number; label: string }>;
  onPreviewTemplate: (template: WorkflowTemplate) => void;
  onImportTemplate: (template: WorkflowTemplate) => void;
  onClose: () => void;
}

const TemplateListView: React.FC<TemplateListViewProps> = ({
  templates,
  categories,
  onPreviewTemplate,
  onImportTemplate,
  onClose
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 overflow-y-auto p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-white">{t('canvas.templates.dialog.templateList')}</h3>
        {/* 搜索框（可选） */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {templates.map((template) => (
          <div
            key={template.id}
            className="border border-gray-700 rounded-lg p-3 cursor-pointer transition-all hover:border-blue-400 hover:shadow-lg hover:shadow-blue-900/20 bg-gray-800/60 backdrop-blur-sm flex flex-col"
            onClick={() => onPreviewTemplate(template)}
          >
            <div
              className="rounded-lg mb-4 overflow-hidden min-h-40"
            >
              {/* 模板预览图 */}
              {template.extras?.preview_url ? (
                <img
                  src={template.extras.preview_url}
                  alt={`${template.name} preview`}
                  className="w-full h-auto object-contain"
                />
              ) : (
                <div className="w-full h-48 flex items-center justify-center">
                  <span className="text-gray-400 text-sm">{t('canvas.templates.dialog.preview')}</span>
                </div>
              )}
            </div>
            <h4 className="font-semibold mb-3 text-white text-base">{template.name}</h4>

            {/* 使用按钮 */}
            <button
              className="mt-auto w-full bg-blue-600 hover:bg-blue-500 text-white font-medium rounded-lg px-4 py-2 text-sm transition-all hover:shadow-md hover:shadow-blue-900/30 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-gray-800"
              onClick={(e) => {
                e.stopPropagation(); // 阻止事件冒泡，避免触发卡片点击
                onImportTemplate(template);
                onClose();
              }}
            >
              {t('canvas.templates.dialog.use')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateListView;